import { Pipe, PipeTransform } from '@angular/core';  
import { DatePipe } from '@angular/common';
// import { DatePipe } from '@angular/common';  

@Pipe({
    name: 'dateFormatPipe',
    standalone: false
})  
  
export class DateFormatPipe implements PipeTransform {  
    transform(projetList:any, startDate: string, endDate: string,type:string):any {  
        var filteredArray = new Array();  
        var pdfFilteredArray = new Array();  
  
        var datePipe = new DatePipe("en-US");  
        startDate = datePipe.transform(startDate, 'MM/dd/yyyy');  
        endDate = datePipe.transform(endDate, 'MM/dd/yyyy');  
  
        if (projetList && projetList.length && type !== 'pdfInpatient') {     
            projetList.forEach(proj => {  
                // var projectStartDate = datePipe.transform(proj.medicationPrescriptionDate, 'MM/dd/yyyy');  
                // var projectEndDate = datePipe.transform(proj.dateFin, 'dd/MM/yyyy')  
                if(type == 'medication'){
                    if (proj.medicationPrescriptionDate >= startDate && proj.medicationPrescriptionDate <= endDate) {  
                        filteredArray.push(proj);  
                    } 
                } 

                if(type == 'inPatient'){
                    if (proj.memberAdmitDate >= startDate && proj.memberAdmitDate <= endDate) {  
                        filteredArray.push(proj);  
                    } 
                } 

              
            });  
        }else if(type == 'pdfInpatient'){
            projetList.value.forEach(pdf=>{
                
                if (pdf.memberAdmitDate >= startDate && pdf.memberAdmitDate <= endDate) {  
                    pdfFilteredArray.push(pdf);  
                } 
          }
          );
          return pdfFilteredArray;
        }

        //   if(type == 'pdfInpatient' && projetList){

        //         } 

        if(filteredArray.length > 0){
            return filteredArray;  
        }else{
            filteredArray.push('No clinical events exist for the selected type, member and date');
            return filteredArray;
        }
        
    }  
}  